<template>
  <el-row>
    <el-col>
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>编辑推荐</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col>
      <el-row>
        <el-col :span="8" class="block">
          <el-col>
            <el-tree :props="initCategoryProps" @node-click="clickNode" v-loading="loading" :load="loadCategory" node-key="PID_id" ref="tree" highlight-current lazy show-checkbox  :expand-on-click-node="false">
               <span class="custom-tree-node" slot-scope="{ store, node, data }">
                <span>{{ node.label }}</span>
                <span>
                  <el-button type="text" size="mini" @click="newrecommend(data)"><i class="el-icon-plus"></i>新增推荐</el-button>
                </span>
              </span>
            </el-tree>
            <el-dialog :visible.sync="addDialogVisible" :before-close="handleClose" width="30%">
            <span>
                <el-form name="spudata" :model = "spudata" ref= "spudata">
                  <el-form-item label="推荐SPU" prop="spus" :rules="{required: true, message: '请输入编辑推荐的产品SPU', trigger: 'blur'}">
                    <el-input v-model="spudata.spus" rows="10" type="textarea" placeholder="请输入编辑推荐的产品SPU（一行一个)" required></el-input>
                  </el-form-item>
                  <el-form-item label="推荐时间" prop="endTime" :rules="{required: true, message: '选择推荐结束日期', trigger: 'blur'}">
                    <el-date-picker type="datetime" placeholder="选择推荐结束日期" v-model="spudata.endTime" value-format="yyyy-MM-dd HH:mm:ss" @change="endTimeChange" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                  <el-form-item style="text-align: right">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleNewRecommend('spudata')">确 定</el-button>
                  </el-form-item>
                </el-form>
              </span>
          </el-dialog>
          </el-col>
        </el-col>
        <el-col :span="16" class="edittags">
          <el-row>
            <el-col>
              <div class="tb_header">
                <div class="title"><h3><i class="el-icon-menu"></i>编辑推荐列表</h3></div>
                <el-col>
                  <el-table :data="pageinfo.data"  stripe style="width: 100%">
                    <el-table-column prop="child[0].cover" label="封面" width="100">
                      <template slot-scope="scope">
                        <img :src="scope.row.child[0].cover" width="100%"/>
                      </template>
                    </el-table-column>
                    <el-table-column prop="spu" label="SPU" width="200"></el-table-column>
                    <el-table-column prop="itemsku" label="商户SKU" width="150"></el-table-column>
                    <el-table-column prop="title" label="产品标题" width="300"></el-table-column>
                    <el-table-column prop="brandName" label="产品品牌" width="110"></el-table-column>
                    <el-table-column prop="currency" label="货币" width="50"></el-table-column>
                    <el-table-column prop="salePrice" label="销售价" width="110"></el-table-column>
                    <el-table-column prop="status" :formatter="spustate" label="状态" width="50"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                      <template slot-scope="scope">
                        <el-button type="text" size="small">改时</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :span="24" class="pagenav" style="margin-top: 42px;">
                  <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="pageinfo.page"
                  :page-sizes="[12]"
                  :page-size="12"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pageinfo.total">
                </el-pagination>
              </el-col>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'EditorRecommend',
  data () {
    return {
      sData: {},
      pageinfo: {page: 0, total: 0, num: 15, data: []},
      initCategoryProps: {
        label: 'name',
        children: 'zones',
        isLeaf: true
      },
      categorydata: [],
      addattriDialogVisible: false,
      categoryAddTemp: '',
      categoryAddData: {},
      addrules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        uri: [{ required: true, message: '分类uri不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '分类标题不能为空', trigger: 'blur' }],
        keywords: [{ required: true, message: '分类关键词不能为空', trigger: 'blur' }],
        description: [{ required: true, message: '分类介绍不能为空', trigger: 'blur' }]
      },
      loading: false,
      attriload: false,
      addDialogVisible: false,
      attridata: [],
      currSelectedNode: {},
      currEditdata: {},
      currdata: [],
      currcategory: {},
      spudata: {endTime: ''},
      endtime: ''
    }
  },
  mounted: function () {
    this.handleCurrentChange(1)
  },
  methods: {
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    loadCategory (node, resolve) {
      var tempdata = node.data
      if (node.level === 0) {
        var data = {
          name: '店铺根目录',
          PID_id: 0,
          ID: 0
        }
        return resolve([data])
      } else {
        var tid
        tid = tempdata.ID
        if (tid === null) {
          tid = 0
        }
        this.LoadChildCategory(tid, resolve)
      }
    },
    LoadChildCategory (pid, resolve) {
      var that = this
      var params = {
        PID_id: pid,
        method: 'shop.childcategory'
      }
      this.$http.post(that.$apiurl, params).then(function (ret) {
        resolve(ret.body.data)
      })
    },
    insert (data, child) {
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(child)
    },
    remove (node, data) {
    },
    clickNode (d) {
      this.currcategory = d
      this.currSelectedNode = d
      this.handleCurrentChange(1)
    },
    handleCurrentChange: function (page) {
      var params = this.sData
      params['page'] = page
      params['num'] = 12
      params['method'] = 'shop.recommentpage'
      if (this.currcategory.ID !== undefined) {
        params.category_id = this.currcategory.ID
        var that = this
        this.$http.post(that.$apiurl, params).then(function (ret) {
          that.pageinfo = ret.body.data
        })
      }
    },
    newrecommend: function (row) {
      this.currcategory = row
      this.addDialogVisible = true
    },
    handleNewRecommend: function (formname) {
      var that = this
      that.$refs[formname].validate(function (valid) {
        if (valid) {
          var para = that.spudata
          console.log(that.spudata)
          para.method = 'shop.addrecommend'
          para.category_id = that.currcategory.ID
          para.endTime = that.endtime
          that.$http.post(that.$apiurl, para).then(function (ret) {
            if (ret.body.data.code === 200) {
              that.$message.success('编辑推荐提交成功')
              that.addDialogVisible = false
              that.handleCurrentChange(1)
            } else {
              that.$alert('编辑推荐提交失败,请稍后重试!')
            }
          })
        }
      })
    },
    spustate: function (data) {
      if (data.status) {
        return ('在售')
      } else {
        return ('禁售')
      }
    },
    endTimeChange: function (v) {
      this.spudata.endTime = v
      console.log(v)
      this.endtime = v
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/market/EditorRecommend.vue